import { render, staticRenderFns } from "./HdRichTextEditor.vue?vue&type=template&id=74c54baa"
import script from "./HdRichTextEditor.vue?vue&type=script&lang=js"
export * from "./HdRichTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports